import * as IntroFns from '../utilities/IntroFns';
import {useState, useEffect} from 'react';
import IntroPiece from './IntroPiece';
import ColorBar from '../PopUps/ColorBar';
import * as ActionModifiers from '../ActionModifiers';

function App(props) {

  var width = props.width;
  var height = props.height;
  var addToExtraScreen = props.addToExtraScreen;
  var scrollAmt = props.scrollAmt;
  var chains = props.chains;
  var isShowingPrevious = props.isShowingPrevious;

  var colorCombo = props.colorCombo;
  var setColorCombo = props.setColorCombo;
  var customColorRecord = props.customColorRecord;
  var setCustomColorRecord = props.setCustomColorRecord;
  var isShowingCustom = props.isShowingCustom;
  var setIsShowingCustom = props.setIsShowingCustom;
  var palette = props.palette;
  var changeTab = props.changeTab;

  const [templates, setTemplates] = useState(false);
  const [counter, setCounter]= useState(0);

  function incrementCounter(){
    setCounter(counter + 1);
  }

  useEffect(() => {
    IntroFns.refreshTemplatesWithCategories(setTemplates, isShowingPrevious);
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

// 
  var expressedWidth = (width - 200);
  if (width >= 768){
    expressedWidth = (width - 200) * 5/12;
  }else{
    expressedWidth = (width - 200) * 10/12;
  }

  expressedWidth = expressedWidth * 0.6;

  function showTemplates(index){
    return function(e){
      addToExtraScreen({t:'templates',v:templates,i:index})
      e.stopPropagation();
    }
  }

  var templatesOut;
  if (!templates){
    templatesOut = <div className='col-12 text-center'><p className='lead mb-0'>Loading...</p></div>
//
  }else{

    var modOptions = [];

    var templatesOut1 = templates.map((aTemplate, index)=>{


      var aTemplate1 = JSON.parse(JSON.stringify(aTemplate));
      var components = ActionModifiers.getColorComponents(isShowingCustom, customColorRecord, palette, colorCombo);
      var modOptions1 = ActionModifiers.findIssues(aTemplate1.c, components, 'selectNew', chains, changeTab);
      modOptions = modOptions.concat(modOptions1);

      return <IntroPiece chains={chains} key={index} expressedWidth={expressedWidth} width={width} height={height} onClick={showTemplates(index)} aTemplate={aTemplate1} scrollAmt={scrollAmt} />
    })
    templatesOut = 
        <table><tbody><tr>
          <td style={{verticalAlign:'top', width:(width - 200)}}><div className='container'><div className='row'>
            {templatesOut1}
          </div></div></td>
          <td style={{verticalAlign:'top', width:200}}><ColorBar colorCombo={colorCombo} setColorCombo={setColorCombo} incrementCounter={incrementCounter}  customColorRecord={customColorRecord} setCustomColorRecord={setCustomColorRecord} isShowingCustom={isShowingCustom} setIsShowingCustom={setIsShowingCustom} modOptions={modOptions} palette={palette} counter={counter} height={height}/></td>

        </tr></tbody></table>
  }
//
  return <div className='row' >
      {templatesOut}
    </div>
//

//
}

export default App;
